import { Component, Input, input } from "@angular/core";
import { NgClass } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";

@Component({
	selector: "stages-navigation-entry-single-line",
	templateUrl: "./single-line-navigation-entry.component.html",
	styleUrls: ["./single-line-navigation-entry.component.scss"],
	imports: [NgClass, TranslateModule],
})
export class SingleLineNavigationEntryComponent {
	// TODO: Skipped for migration because:
	//  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
	//  and migrating would break narrowing currently.
	@Input()
	entry!: SingleLineEntry;

	readonly mode = input<NAV_ENTRY_DISPLAY_MODE>();
}
